import { formatPalletLabel } from "../../../../../ProduccionV2/helpers/formatPallet";

export const formatExistenciasLabel = (
    existencia,
    mostrarConformidad = true,
) => {
    const esConforme = existencia.es_conforme_bodega;
    const textoConforme = esConforme ? "Conforme" : "No conforme";

    const pallet = formatPalletLabel(
        existencia.numero_pallet,
        existencia.identificador_fisico,
    );

    if (mostrarConformidad) return `${pallet} - ${textoConforme}`;
    else return pallet;
};

export const formatSobranteLabel = (existencia) => {
    const esConforme = existencia.es_conforme_bodega;
    const textoConforme = esConforme ? "Conforme" : "No conforme";

    return `${existencia.producto} - ${textoConforme}`;
};
